module.exports = __webpack_public_path__ + "img/slughorns_arm_chair_pajamas.fa02c729.jpg";